import { render, staticRenderFns } from "./Zfyzadmin.vue?vue&type=template&id=4dd52297&scoped=true"
import script from "./Zfyzadmin.vue?vue&type=script&lang=js"
export * from "./Zfyzadmin.vue?vue&type=script&lang=js"
import style0 from "./Zfyzadmin.vue?vue&type=style&index=0&id=4dd52297&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd52297",
  null
  
)

export default component.exports